import { Link } from 'react-router-dom';
import { PROJECTS } from '../data/projects';
import styles from './Portfolio.module.css';

const Portfolio = () => {
    // Show only first 6 projects on homepage
    const displayedProjects = PROJECTS.slice(0, 6);

    return (
        <section id="portfolio" className="section">
            <div className="container">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', marginBottom: '2rem' }}>
                    <h2 className="section-title" style={{ margin: 0 }}>Réalisations / Portfolio</h2>
                    <Link to="/projets" style={{ color: '#00ff9d', textDecoration: 'none', fontWeight: 'bold' }}>
                        Voir tout ({PROJECTS.length}) →
                    </Link>
                </div>

                <div className={styles.portfolioGrid}>
                    {displayedProjects.map((project, index) => (
                        <a
                            href={project.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={index}
                            className={`${styles.portfolioCard} glass`}
                            style={{
                                animationDelay: `${index * 0.1}s`,
                                '--theme-color': project.themeColor
                            } as React.CSSProperties}
                        >
                            <div className={styles.portfolioImage}>
                                <iframe
                                    src={project.url}
                                    title={`Aperçu de ${project.title}`}
                                    className={styles.projectFrame}
                                    loading="lazy"
                                    tabIndex={-1}
                                    scrolling="no"
                                />
                                <div className={styles.portfolioOverlay}>
                                    <span className={styles.viewProject}>Voir le projet →</span>
                                </div>
                            </div>

                            <div className={styles.portfolioContent}>
                                <span className={styles.portfolioCategory}>{project.category}</span>
                                <h3 className={styles.portfolioTitle}>{project.title}</h3>
                                <p className={styles.portfolioDescription}>{project.description}</p>

                                <div className={styles.portfolioTags}>
                                    {project.tags.map((tag, i) => (
                                        <span key={i} className={styles.tag}>{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </a>
                    ))}
                </div>

                <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                    <Link to="/projets" className="btn btn-secondary">
                        Afficher tous les autres projets
                    </Link>
                </div>

                <div className={styles.portfolioCta}>
                    <h3 className={styles.ctaTitle}>Un projet en tête ?</h3>
                    <p className={styles.ctaText}>Discutons de vos besoins et construisons ensemble quelque chose d'unique.</p>
                    <a href="#contact" className="btn btn-primary">Lancer la conversation</a>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
